// Copyright (C) 2021-2022 Intel Corporation
//
// SPDX-License-Identifier: MIT

import React from 'react';
import Image from 'antd/lib/image';
import Paragraph from 'antd/lib/typography/Paragraph';
import Text from 'antd/lib/typography/Text';

interface Props {
    name?: string;
    gif?: string;
    message?: string;
    withNegativePoints?: boolean;
}

function InteractorTooltips(props: Props): JSX.Element {
    const {
        name, gif, message, withNegativePoints,
    } = props;
    const UNKNOWN_MESSAGE = '选中的交互模型没有说明';
    const desc = message || UNKNOWN_MESSAGE;
    return (
        <div className='cvat-interactor-tip-container'>
            {name ? (
                <>
                    <Paragraph>{desc}</Paragraph>
                    <Paragraph>
                        <Text>鼠标左键用于扩大范围，包含一些有意义的区域。</Text>
                        {withNegativePoints ? (
                            <Text>鼠标右键用于缩小范围，去除一些无意义的区域。</Text>
                        ) : null}
                    </Paragraph>
                    <Paragraph>
                        <Text>可以按住</Text>
                        <Text strong>{' Ctrl '}</Text>
                        <Text>键延迟向服务器发送请求。</Text>
                    </Paragraph>
                    {gif ? <Image className='cvat-interactor-tip-image' alt='示例 GIF' src={gif} /> : null}
                </>
            ) : (
                <Text>选择一个交互模型查看说明</Text>
            )}
        </div>
    );
}

export default React.memo(InteractorTooltips);
